<template>
  <div v-if="field.detail_show">
    <div class="field_prev" v-if="field.field_prev">{{ field.field_prev }}</div>
    <!--textarea类型-->
    <div
      class="field_cell"
      v-if="field.field_type == 'textarea'"
      v-show="field.field_required || field.field_value !== ''"
    >
      <div class="field_body flex_column">
        <div class="field_row">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}
        </div>
        <div class="field_row">
          <div class="field_textarea">
            <span>{{ field.field_value }}</span>
          </div>
        </div>
      </div>
      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>
    <!--checkbox-->
    <div
      class="field_cell"
      v-if="field.field_type == 'checkbox'"
      v-show="field.field_required || field.field_value !== ''"
    >
      <div class="field_body flex_column">
        <div class="field_row">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}
        </div>
        <div class="field_row">
          <div class="field_textarea">
            <span>{{ (field.field_value || []).join(', ') }}</span>
          </div>
        </div>
      </div>
      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>
    <!--files类型-->
    <div
      class="field_cell"
      v-else-if="field.field_type == 'files'"
      v-show="field.field_required || field.field_value.length > 0"
    >
      <div class="field_body">
        <div class="field_row">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}（{{ field.field_value.length || 0 }}/{{
            field.field_length
          }}）
        </div>
      </div>
      <div class="field_row">
        <div class="file_flex">
          <div
            class="file_cell"
            v-for="(file, file_index) in field.field_value"
            :key="file.file_id"
            @click="onOpenFile(file, file_index)"
          >
            <van-image
              fit="cover"
              class="file_icon"
              :src="Util.getImgUrl(file.type == 'image' ? file.thumb_src : file.icon)"
              mode="aspectFill"
            />
          </div>
        </div>
      </div>
      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>
    <!-- users类型 -->
    <div class="field_cell" v-else-if="field.field_type == 'users'">
      <div class="field_body">
        <div class="field_left">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}
        </div>
      </div>
      <div class="field_row">
        <div class="node_users">
          <template v-if="field.field_value && field.field_value.length">
            <div class="user_cell" v-for="user in field.field_value" :key="user.uid">
              <van-image
                round
                v-if="user.avatar"
                class="avatar"
                :src="Util.getImgUrl(user.avatar)"
                >{{ user.realname }}
              </van-image>
              <div v-else class="avatar_name">
                {{ Util.miniName(user.realname) }}
              </div>
              <div class="realname">{{ user.realname }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>
    <!-- cost_details -->
    <div class="field_cell" v-else-if="field.field_type == 'cost_details'">
      <div class="field_body">
        <div class="field_left">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}
        </div>
      </div>
      <div class="field_row">
        <label
          class="field_checkbox"
          v-for="detail in field.field_value.details"
          :key="detail.name"
        >
          <span class="required" v-if="detail.required">*</span>
          <div>{{ detail.name }}</div>
          <div class="field_right">
            <div class="text-align-right">
              {{ detail.value ? detail.value : 0 }}
            </div>
          </div>
        </label>
        <label class="field_checkbox" style="font-weight: 500">
          <div>费用预算合计</div>
          <div class="field_right">
            <div class="text-align-right">{{ field.field_value.sum }}</div>
          </div>
        </label>
      </div>
      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>

    <!-- relate_task -->
    <div class="field_cell" v-else-if="field.field_type == 'relate_task'">
      <div class="field_body">
        <div class="field_left">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}
        </div>
      </div>

      <div class="node_field_box" v-if="field.field_value.fields.length">
        <div class="sub_name">
          <div>{{ field.field_value.realname }}的{{ field.field_value.type_name }}</div>
          <div>
            任务编号：{{
              field.field_value.task_id
                ? field.field_value.task_id
                : field.field_value.approve_id
            }}
          </div>
        </div>
        <div
          class="sub_field_cell_box"
          v-for="relate_task_field in field.field_value.fields"
          :key="relate_task_field.field_id"
          v-show="
            relate_task_field.field_required || relate_task_field.field_value !== ''
          "
        >
          <taskField :field.sync="relate_task_field"></taskField>
        </div>
      </div>

      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>

    <!-- 文本类型 -->
    <div
      class="field_cell"
      v-else
      v-show="field.field_required || field.field_value !== ''"
    >
      <div class="field_body">
        <div class="field_left">
          <span class="required" v-if="field.field_required">*</span
          >{{ field.field_name }}
        </div>
        <div class="field_right">
          <div class="div-align-right">{{ field.field_value }}</div>
        </div>
      </div>
      <div class="field_footer" v-if="field.field_tips">
        <span class="field_tips">{{ field.field_tips }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import taskField from "./taskField.vue";
export default {
  components: {
    taskField,
  },
  name: "taskField",
  props: {
    field: Object,
  },
  methods: {},
};
</script>
<style scoped>
/* field */
.field_prev {
  margin-top: 20px;
  background-color: #fff;
  padding: 30px 30px;
  font-size: 32px;
  font-weight: 900;
  margin-bottom: 1px;
}

.field_cell {
  background-color: #fff;
  padding: 30px 30px;
}

.field_body {
  display: flex;
  justify-content: space-between;
}

.flex_column {
  flex-direction: column;
}

.flex_row {
  flex-direction: row;
}

.field_footer {
  margin-top: 15px;
}

.field_left {
  max-width: 60%;
}

.field_right {
  flex: 1;
  padding-left: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.field_row {
  width: 100%;
}

.field_input {
  width: 100%;
  text-align: right;
}

.placeholder_input {
  color: #999;
}

.field_text {
  width: 100%;
  text-align: right;
}

.field_textarea {
  width: 100%;
  margin-top: 30px;
}

.field_textarea span {
  white-space: pre-wrap;
  line-height: 44px;
}

.field_picker {
  width: 100%;
  text-align: right;
}

.placeholder_picker {
  color: #999;
}

.field_tips {
  color: #d6151e;
  font-size: 24px;
}

.required {
  color: #d6151e;
}

.text-align-right {
  text-align: right;
  width: 100%;
}

/* file */
.file_flex {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
}

.file_cell {
  padding: 15px 10px;
  background-color: rgba(183, 183, 183, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px 14px 10px 0;
  position: relative;
}

.file_icon {
  width: 80px;
  height: 80px;
}

/* user */

.node_users {
  display: flex;
  flex-wrap: wrap;
  background-color: #eee;
  margin-top: 20px;
  padding: 0 15px;
  border-radius: 15px;
}

.user_cell {
  text-align: center;
  margin: 20px 12px 20px 12px;
}

.add_cell {
  margin: 20px 15px;
}

.user_cell .avatar {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: #7c7c7c;
}

.user_cell .avatar_name {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  line-height: 75px;
  color: #fff;
  font-weight: 500;
  background-color: #a3dfff;
  text-align: center;
}

.user_cell .realname {
  font-size: 26px;
}

.field_checkbox {
  display: flex;
  align-items: center;
  padding: 30px 0;
  border-bottom: 1px solid #eee;
}

.node_field_box {
  border: 2px solid #eee;
  border-radius: 15px;
  margin-top: 20px;
}

.node_field_box > .sub_name {
  padding: 20px 30px;
  font-weight: bold;
  font-size: 28px;
  background-color: #eee;
}

.sub_field_cell_box {
  border-bottom: 2px solid #eee;
}

.sub_field_cell_box:last-child {
  border-bottom: 0;
}
</style>
